import { render, staticRenderFns } from "./Kia2024Ev9Disclosure.vue?vue&type=template&id=088e2202&"
import script from "./Kia2024Ev9Disclosure.vue?vue&type=script&lang=js&"
export * from "./Kia2024Ev9Disclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports